import React, { useReducer, createContext, useContext } from "react";
import { getSelectedFilterValues, getPopulatedPortalFilters } from "../helpers/GlobalStorageHelper";
import { localStorageSave } from "../helpers/GlobalHelper";
import { GlobalConstants } from "./constants/GlobalConstants";
import { IInfoMessage } from "./interfaces/Lms";

export const localStorageGet = (key: string, storageType = "local") => {
  let item: any = null;
  if (storageType === "local") {
    item = localStorage.getItem(key);
  }

  if (storageType === "session") {
    item = sessionStorage.getItem(key);
  }

  if (!item) return;
  if (item[0] === "{" || item[0] === "[") return JSON.parse(item);
  return item;
};

export const Reducer = (state: any, { type, payload }: any) => {
  const filtersListInitialStorage = `filterslistInitial${payload?.storageId || state?.storageId || window.location.pathname}`;
  const filtersListStorage = `filterslist${payload?.storageId || state?.storageId || window.location.pathname}`;
  const activeFiltersListStorage = `activefilterslist${payload?.storageId || state?.storageId || window.location.pathname}`;
  const filtersIsOpenStorage = `filtersisopen${payload?.storageId || state?.storageId || window.location.pathname}`;
  const searchStorage = state?.searchStorageId || `searchterm${payload?.storageId || window.location.pathname}`;

  switch (type) {
    case GlobalConstants.BCStoreReducerCases.SET_USER:
      return {
        ...state,
        user: payload,
      };
    case GlobalConstants.BCStoreReducerCases.SET_INITIAL_GLOBAL_FILTERS:
      if (payload?.filtersMetaData || payload?.filtersMetaData === null) {
        const populatedFilters = getPopulatedPortalFilters(payload?.filtersMetaData, payload?.hiddenFilters);
        if (payload?.filtersMetaData && populatedFilters) {
          if (!state.filtersList || state.filtersList?.length === 0) {
            localStorageSave(filtersListStorage, populatedFilters, "session");
          }
          localStorageSave(filtersListInitialStorage, populatedFilters, "session");
        }

        return {
          ...state,
          filtersList: (!state.filtersList || state.filtersList?.length === 0) && populatedFilters ? populatedFilters : state.filtersList,
          filtersListInitial: populatedFilters ? populatedFilters : state.filtersListInitial,
          storageId: payload.storageId,
          metadata: payload.filtersMetaData
        };
      }
      else {
        return state;
      }
    case GlobalConstants.BCStoreReducerCases.SET_GLOBAL_FILTERS:
      localStorageSave(filtersListStorage, payload, "session");
      localStorageSave(activeFiltersListStorage, getSelectedFilterValues(payload || []), "session");
      return {
        ...state,
        filtersList: payload,
        activeFilters: getSelectedFilterValues(payload || [])
      };
    case GlobalConstants.BCStoreReducerCases.RESET_GLOBAL_FILTERS:
      localStorageSave(filtersListStorage, state.filtersListInitial, "session");
      return {
        ...state, filtersList: state.filtersListInitial, activeFilters: []
      };
    case GlobalConstants.BCStoreReducerCases.TOGGLE_FILTER:
      localStorageSave(filtersIsOpenStorage, JSON.stringify(!state.isFilterOpen), "session");
      return {
        ...state,
        isFilterOpen: !state.isFilterOpen,
      };
    case GlobalConstants.BCStoreReducerCases.OPEN_FILTER:
      localStorageSave(filtersIsOpenStorage, JSON.stringify(true), "session");
      return {
        ...state,
        isFilterOpen: true,
      };
    case GlobalConstants.BCStoreReducerCases.CLOSE_FILTER:
      localStorageSave(filtersIsOpenStorage, JSON.stringify(false), "session");
      return {
        ...state,
        isFilterOpen: false,
      };
    case GlobalConstants.BCStoreReducerCases.SET_SEARCH_VALUE:
      localStorageSave(searchStorage, payload, "session");
      return {
        ...state,
        searchValue: payload,
      };
    case GlobalConstants.BCStoreReducerCases.SET_ITEMS:
      return {
        ...state,
        ...payload,
      };
    case GlobalConstants.BCStoreReducerCases.SET_INFO:
      return {
        ...state,
        info: payload as IInfoMessage,
      };
  case GlobalConstants.BCStoreReducerCases.SET_IFRAME_OPTIONS:
      return {
        ...state,
        iFrameOptions: payload,
      };
    case GlobalConstants.BCStoreReducerCases.CLEAR_INFO:
      return {
        ...state,
        info: null,
      };
    default:
      return state;
  }
};

const initialState: any = {
  filtersListInitial: localStorageGet(`filterslistInitial${window.location.pathname}`, "session") || {},
  filtersList: localStorageGet(`filterslist${window.location.pathname}`, "session") || {},
  activeFilters: localStorageGet(`activefilterslist${window.location.pathname}`, "session") || [],
  isFilterOpen: localStorageGet(`filtersisopen${window.location.pathname}`, "session") || {},
  searchValue: "",
  info: null
};

const BCGlobalStore = ({ children }) => {
  const [state, dispatch] = useReducer(Reducer, initialState);
  return (
    <Context.Provider value={[state, dispatch]}>{children}</Context.Provider>
  );
};

export const Context = createContext(initialState);
export const useBCGlobalReducer = () => useContext(Context);
export default BCGlobalStore;